import { PLACES_BY_SLUG } from "@/lib/local-seo";

/**
 * Een gemeentepagina met dezelfde naam als een stadspagina (bijv.
 * /taxi/gemeente/ridderkerk vs /taxi/ridderkerk) concurreert om hetzelfde
 * zoekwoord. Die gemeentepagina's verwijzen permanent door naar de stadspagina
 * en staan niet in de sitemap: één zoekintentie = één indexeerbare URL.
 */
export function cityPageForGemeente(gemeenteSlug: string | null | undefined): string | null {
  if (!gemeenteSlug) return null;
  return PLACES_BY_SLUG.has(gemeenteSlug) ? gemeenteSlug : null;
}

export function isGemeenteIndexable(gemeenteSlug: string | null | undefined): boolean {
  return Boolean(gemeenteSlug) && cityPageForGemeente(gemeenteSlug) === null;
}
